const transformParams = (params, obj, new2old = {}) => {
  for (let key in obj) {
    params += `${ new2old[key] || key }=${ obj[key] || '' }&`
  }
  return params;
}
const oldPageList = {
  // 优惠券详情
  'couponDetail': (obj = {}) => {
    // 转成旧有参数, key转换
    const new2old = {
      'franchisee': 'sub_id'
    }
    return transformParams('router=couponDetail&', obj, new2old);
  },
  'videoDetail': (obj = {}) => {
    return transformParams('router=videoDetail&', obj);
  },
  // 'goodsDetail': (obj = {}) => {
  //   return transformParams('router=goodsDetail&', obj);
  // },
  'toStoreDetail': (obj = {}) => {
    return transformParams('router=toStoreDetail&', obj);
  },
  'franchiseeDetail': (obj = {}) => {
    return transformParams('router=franchiseeDetail&', obj);
  },
  // 拼团中心
  'groupCenter': (obj = {}) => {
    return transformParams('router=groupCenter&', obj);
  },
  'communityPage': (obj = {}) => {
    return transformParams('router=communityPage&', obj);
  },
  // 优惠券领取列表
  'couponReceiveListPage': (obj = {}) => {
    return transformParams('router=couponReceiveListPage&', obj);
  },
  // 储值
  'recharge': (obj = {}) => {
    return transformParams('router=recharge&', obj);
  },
  // 当面付
  'transferPage': (obj = {}) => {
    return transformParams('router=transferPay&', obj);
  },
  // 大转盘
  'luckyWheelDetail': (obj = {}) => {
    return transformParams('router=luckyWheelDetail&', obj);
  },
  // 刮刮乐
  'scratch': (obj = {}) => {
    return transformParams('router=scratch&', obj);
  },
  // 砸金蛋
  'goldenEggs': (obj = {}) => {
    return transformParams('router=goldenEggs&', obj);
  },
  // 商家入驻
  'franchiseeEnter': (obj = {}) => {
    return transformParams('router=franchiseeEnter&', obj);
  },
  // 个人中心（应该删除）
  'userCenterComponentPage': (obj = {}) => {
    return transformParams('router=userCenterComponentPage&', obj);
  },
  // 门店单页
  'storeSinglePage': (obj = {}) => {
    return transformParams('router=storeSinglePage&', obj);
  },
  // 系统通知
  'myMessage': (obj= {}) => {
    let params = 'router=myMessage&';
    return transformParams('router=myMessage&', obj);
  },
  // 购物车
  'shoppingCart': (obj = {}) => {
    return transformParams('router=shoppingCart&', obj);
  },
  // 我的订单
  'myOrder': (obj = {}) => {
    return transformParams('router=myOrder&', obj);
  },
  // 资讯详情
  'newsDetail': (obj = {}) => {
    return transformParams('router=newsDetail&', obj);
  },
  // 社区详情
  'communityDetail': (obj = {}) => {
    return transformParams('router=communityDetail&', obj);
  },
}
export default oldPageList;


// WEBPACK FOOTER //
// ./src/utils/oldPageList.jsx